import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

export default css`
  .monthly-payment-calculator-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    color: ${colors.BLACK};
    overflow: hidden;
  }

  .header {
    font-size: 25px;
    font-weight: 600;
    line-height: 26px;
    margin-bottom: 20px;
  }

  .description {
    font-size: 18px;
    margin-bottom: 30px;
  }

  .terms {
    font-size: 18px;
    margin-bottom: 30px;
  }

  .down-payment-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
  }
`;
